import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const useForceRerender = () => {
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => history.push(), 1);
  }, []);
};

export default useForceRerender;
